import type { ReactNode } from 'react';

type Props = {
    action?: ReactNode;
    dateAdded?: ReactNode;
    item: ReactNode;
    lastAlert?: ReactNode;
};

/**
 * Row geometry for the For You "My Similar Item Alerts" table, used by both the column header and
 * each alert row. Below `tabletMin` the two date columns collapse into a caption under the lot title
 * (the row renders it), leaving the item and its delete action.
 */
export const MySimilarItemAlertsTableRow = ({ action, dateAdded, item, lastAlert }: Props) => (
    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-sm border-b border-border-secondary p-sm tabletMin:grid-cols-[2fr_1fr_1fr_1fr]">
        {item}
        <div className="hidden tabletMin:block">{lastAlert}</div>
        <div className="hidden tabletMin:block">{dateAdded}</div>
        <div className="text-right">{action}</div>
    </div>
);
